<template>
  <v-tour name="tour" :steps="steps" :options="options" :callbacks="callbacks">
  </v-tour>
</template>

<script>
export default {
  name: "SalesTourComponent",
  data() {
    return {
      callbacks: {
        onSkip: this.tourStepFinish,
        onFinish: this.tourStepFinish
      },
      options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Cerrar",
          buttonPrevious: "Anterior",
          buttonNext: "Continuar",
          buttonStop: "Finalizar"
        }
      },
      steps: [
        {
          target: "#app",
          content: `
            <h5>Paso 1 de 3</h5>
            <h6>Crea tu primera cotización</h6>
            <p>Envía propuestas profesionales a tus clientes, controla versiones y mira en qué estado va cada una.</p>
          `,
          params: { placement: "top" }
        },
        {
          target: "#app",
          content: `
            <h5>Paso 2 de 3</h5>
            <h6>Convierte cotizaciones en facturas en un clic</h6>
            <p>Configura tu firma electrónica y emite facturas, notas de crédito y retenciones autorizadas por el SRI sin salir de Mydessk.</p>
          `,
          params: { placement: "top" }
        },
        {
          target: "#app",
          content: `
            <h5>Paso 3 de 3</h5>
            <h6>Cobra más rápido con links de pago</h6>
            <p>Comparte un link y recibe pagos online. Lleva el control de ingresos y cuentas por cobrar en tiempo real.</p>
          `,
          params: { placement: "top" }
        }
      ]
    };
  },
  computed: {},
  methods: {
    tourStepFinish() {
      const userConfigGeneral = {
        is_sales_tour_completed: 1
      };
      this.$store.dispatch("userConfigGeneralUpdated", userConfigGeneral);
    }
  },
  components: {},
  mounted() {
    this.$tours["tour"].start();
  }
};
</script>

<style lang="scss" scoped></style>
